'use strict';

import Vue from 'vue';

import entry from './entry.vue';

Vue.component('tg-webcast-entry', entry);